import i from "./ghl-ui.es420.js";
import t from "./ghl-ui.es745.js";
function f(r) {
  return t(r) && i(r);
}
export {
  f as default
};
